import React from "react";
import { AiFillLinkedin } from "react-icons/ai";
import { BsGithub } from "react-icons/bs";
import { SiLeetcode } from "react-icons/si";
const HeaderSocial = () => {
  return (
    <div className="header__socials">
      <a
        href="https://www.linkedin.com/in/krishan-kumar-safi-024794224/"
        target="_blank"
      >
        <AiFillLinkedin />
      </a>
      <a href="https://github.com/Krishukr12" target="_blank">
        <BsGithub />
      </a>
      <a href="https://leetcode.com/krishukr/" target="_blank">
        <SiLeetcode />
      </a>
    </div>
  );
};

export default HeaderSocial;
